<template>
  <div>

    <AppBreadcrumb 
      @fetch-excel="downloadListadoDoctores('excel')" 
      @fetch-pdf="downloadListadoDoctores('pdf')"
    />

    <b-row class="my-2">
      
      <b-form-input 
        v-model="filters.search" 
        placeholder="Buscar por nombres, apellidos o cedula"
        type="text" 
        class="col-6" 
      />
      
      <v-select 
        class="col-4"
        placeholder="Buscar por especialidad" 
        v-model="filters.especialidad" 
        :options="optionsEspecialidades" 
        :reduce="option => option" 
        label="text"
      />        

      <div>
        <b-button variant="primary" @click="buscarDoctor">
          <font-awesome-icon 
            icon="magnifying-glass" 
            style="color: white;" 
          /> 
          Buscar
        </b-button>
      </div>

    </b-row>

    <b-overlay opacity="0.50" rounded="sm">
      <b-card class="principal">

        <div class="d-flex justify-content-between mb-1 mx-1">
          <div class="d-flex text-success align-items-center">
            <i class="fa-solid fa-filter"/>
            <span class="mx-1" v-html="getFiltrosAplicados"></span>
          </div>
          <h5>Resultados: {{ table.totalRows }}</h5>
        </div>

        <b-col cols="12" class="pr-0 pl-0 mt-2">

          <b-skeleton-wrapper v-if="loadingTable">
            <b-skeleton
              v-for="i in 15"
              :key="i"
              width="100%" 
              height="50px"
            />
          </b-skeleton-wrapper>

          <b-table 
            v-if="items.length > 0 && !loadingTable" 
            bordered striped responsive 
            :per-page="table.size"
            :items="items" 
            :fields="fieldsTable" 
          >
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">
                <b-button 
                  variant="info" 
                  size="sm" 
                  @click="viewItem(data.item.tokenDoctor)"
                >
                  <font-awesome-icon 
                    icon="magnifying-glass" 
                    style="color: white;" 
                  />
                </b-button>

                <b-button 
                  variant="primary" 
                  size="sm" 
                  @click="editItem(data.item.tokenDoctor)"
                >
                  <font-awesome-icon 
                    icon="user-pen" 
                    style="color: white;" 
                  />
                </b-button>

                <b-button 
                  variant="danger" 
                  size="sm" 
                  @click="removeItemid(data.item.idDoctor)"
                >
                  <font-awesome-icon 
                    icon="circle-xmark" 
                    style="color: white;" 
                  />
                </b-button>
              </div>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination 
            v-model="table.page" 
            :total-rows="table.totalRows"
            :per-page="table.size"
            first-number 
            class="mb-0" 
            align="center" 
            prev-class="prev-item"
            next-class="next-item" 
            @change="onChangePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>

            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>


    <VerDoctor/>
  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import actions from '@/assets/utils/utils'
import vSelect from 'vue-select'
import axios from 'axios';
import { comprobarPermisos } from "@/shared/helpers";
import rutas from '@/assets/utils/rutas.json';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'; // Update the path accordingly
import { getEstablecimientoLS } from '@/shared/helpers/dataLocalStorage';
import { doctoresService } from '../../services';
import VerDoctor from './VerDoctor.vue';

export default {
  components: {
    ...BootstrapVue.components,
    AppBreadcrumb,
    vSelect,
    VerDoctor
  },
  data() {

    return {

      loadingTable:false,

      filters:{
        search:null,
        especialidad:null,
      },

      filtersCopy:{},

      table: {
        page: 1,
        size: 15,
        totalRows: 0
      },

      optionsEspecialidades: [],
      login_user: '',
      consultardoc: null,

      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      idEstablecimiento: null,

      fieldsTable: [
        { key: 'nombres',          label: 'Nombres',         sortable: true, thClass: 'text-center' },
        { key: 'especialidad',     label: 'Especialidad',    sortable: true, thClass: 'text-center' },
        { key: 'usuario',          label: 'Usuario',         sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'acciones',         label: 'acciones',        sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],

      items: [],
      descripcion: '',
      
    }
  },


  async created() {
    comprobarPermisos(this.$route);
    
    this.getDataTable();
    this.fetchEspecilidades()
    this.setToken();
  },

  mounted() {
    actions.setearTitulo('Doctor')
  },


  methods: {

    async fetchEspecilidades() {
      const query = `
        query MyQuery {
          allEspecialidad {
            descripcion
            id
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });

        this.optionsEspecialidades = response.data.data.allEspecialidad.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,
          })
        );
      } catch (error) {
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
       

    onRowSelected(items) {
      this.selected = items
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    onChangePage(page) {
      this.table.page = page;
      this.getDataTable();
    },

    async getDataTable(){

      this.filtersCopy = { ...this.filters };

      this.loadingTable = true;
      const establecimiento = getEstablecimientoLS()?.id

      const params = {
        establecimiento: establecimiento,
        search       : this.filters.search,
        especialidad : this.filters.especialidad?.value,
        page         : this.table.page,
        pageSize     : this.table.size,
      }

      const responseDoctores = await doctoresService.getAll(params);

      if(!responseDoctores) return;

      this.items = responseDoctores.doctores.map( d => {
        const dataPersona = d.idPersona;

        const usuario = d.idPersona.detalleusuarioSet?.[0].usuario.username;
        
        return {
          idDoctor         : d.id,
          tokenDoctor      : d.token,
          identificacion   : d.idPersona.identificacion,
          nombres          : `${dataPersona.identificacion} - ${dataPersona.primerApellido} ${dataPersona.primerNombre}`, // Aquí está la combinación
          usuario          : usuario,
          especialidad     : d.especialidad.descripcion,
        }
      });

      this.table.totalRows = responseDoctores.total;
      this.loadingTable = false;
    },



    viewItem(tokenDoctor) {
      this.navigateToQuery('view', tokenDoctor)
    },
    
    editItem(tokenDoctor) {
      this.$router.push({
        name: 'editar_doctor',
        params: { token: tokenDoctor }
      });
    },

    removeItemid(idDoc) {
      const mesa = this.fetchRemoveDoctor(idDoc);
    },



    async fetchRemoveDoctor(idDoc) {

      this.$swal({
        title: 'Estas seguro de eliminar doctor?',
        text: "No seras capaz de revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Borrar esto!',
        cancelButtonText: 'No, cancelar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Call the API or method to remove the item here
          try {

            const query = `
              mutation removerDoctor ($id: String!){
                removerDoctor(idDoc:$id){
                  doctor {
                    token
                  }
                  status,
                  message
                }
              }
            `;

            const variables = {
              id: idDoc,
            };

            const response = await axios.post(rutas.axios + 'api', { query, variables });


            if (response.status === 200) {
              if (response.data.data.removerDoctor.status === 'success') {
                if (response.status === 200) {
                  this.$swal({
                    title: 'Borrado!',
                    text: 'Tu registro ha sido eliminado',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router.push({ name: 'consultar_doctor' }).catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                  }
                });
              } else {
                this.$swal({
                  title: 'Error',
                  text: response.data.data.removerDoctor.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                })
              }
            }
          } catch (err) {
            console.log(err);
            return 'Error al eliminar doctor';
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: 'Cancelado',
            text: 'Your registro esta seguro :)',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          });
        }
      });

    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    async downloadListadoDoctores(tipo = 'excel') {
      const establecimiento = getEstablecimientoLS()?.id

      const params = {
        establecimiento: establecimiento,
        search         : this.filters.search,
        especialidad   : this.filters.especialidad?.value,
        excel          : tipo === 'excel' ? "1" : "0",
        pdf            : tipo === 'pdf'   ? "1" : "0",
      }

      const responseDoctores = await doctoresService.getAll(params);
      if(!responseDoctores) return;

      const dataArchivo = responseDoctores?.archivo

      if (tipo === "excel") 
        actions.cargarArchivos(dataArchivo, "Doctor.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
      
      if (tipo === "pdf") 
        actions.cargarArchivos(dataArchivo, "Doctor.pdf", "data:application/pdf;base64")
      
    },


    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },

    buscarDoctor() {
      this.getDataTable();
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },

  },


  computed:{
    getFiltrosAplicados() {
      const filtrosAplicados = [];

      if(this.filtersCopy.search)
        filtrosAplicados.push(`Busqueda: ${this.filtersCopy.search}`)

      if(this.filtersCopy.especialidad)
        filtrosAplicados.push(`Especialidad: ${this.filtersCopy.especialidad.text}`)

      return filtrosAplicados.join('<br>');
    }
  },

  watch: {
    
  }
}
</script>


<style lang="scss">
@import '@/assets/scss/vue/libs/vue-select.scss';
</style>
